import { formatToLocalDateTime } from '../../../../utils/dateFormatter';
import { CustomDatePicker } from '../../../../components';

import { formatPrice } from '../../price-processing.utils';

import { orderStationsByProvince, getRowClass } from '../utils/priceTableUtils';
import '../GlobalPriceTable/GlobalPriceTable.css';

import { StationPriceTableProps } from './StationPriceTable.types';

/**
 * Renders a station-level price processing table with editable inputs
 * Shows individual station data including region, province, brand, address, and fuel prices

 */
export function StationPriceTable({
  data,
  fuelTypes,
  canProcessOkkoPrices,
  isCellChanged,
  handlePriceInput,
  onDateChange,
  bodyRef,
  resetKey = ''
}: StationPriceTableProps) {
  const sortedData = orderStationsByProvince(data);

  return (
    <div className="price-processing-stations-container">
      <div className="table-wrapper" ref={bodyRef}>
        <div className="price-processing-table">
          {sortedData.map((item, index) => (
            <div key={index} className={getRowClass(item, true)}>
              <div className="price-processing-table-cell price-processing-region-col">{item.region}</div>
              <div className="price-processing-table-cell price-processing-province-col">{item.province}</div>
              <div className="price-processing-table-cell price-processing-brand-col">{item.brand}</div>
              <div className="price-processing-table-cell price-processing-address-col">{item.address}</div>
              <div className="price-processing-table-cell price-processing-last-date-col">
                {formatToLocalDateTime(item.lastUpdate)}
              </div>
              {fuelTypes.map(fuel => (
                <div
                  key={fuel}
                  className={`price-processing-table-cell price-processing-fuel-col ${isCellChanged(item, fuel) ? 'cell-changed' : ''}`}
                >
                  {item.isEditable && !(item.isOkko && fuel === 'AdBlue') ? (
                    <input
                      type="text"
                      className={`price-input ${item.isOkko && !canProcessOkkoPrices ? 'not-allowed' : ''}`}
                      value={formatPrice(item.prices[fuel])}
                      disabled={item.isOkko && !canProcessOkkoPrices}
                      onChange={e => handlePriceInput(e, item, fuel)}
                    />
                  ) : (
                    <span className="price-display">
                      {item.isOkko && fuel === 'AdBlue' ? '' : formatPrice(item.prices[fuel] || 0) || '-'}
                    </span>
                  )}
                </div>
              ))}
              <div
                className={`price-processing-table-cell price-processing-date-col ${isCellChanged(item, 'date') ? 'cell-changed' : ''}`}
              >
                {item.isEditable && !(item.isOkko && !canProcessOkkoPrices) ? (
                  <CustomDatePicker
                    key={`${index}-${resetKey}`}
                    value={item.changeDate ? new Date(item.changeDate) : null}
                    onChange={value => onDateChange(item, value as string)}
                    format="dd.MM.yyyy HH:mm:ss"
                    showTime={true}
                    timeFormat="HH:mm:ss"
                    includeSeconds={true}
                    outputFormat="datetime-local"
                  />
                ) : (
                  <span>{formatToLocalDateTime(item.changeDate)}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
